import React, { Component, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import Circles from "../../assets/images/circle.png";
import SideBar from "./NHBSideBar";
import axios from "axios";
import Chart from "react-apexcharts";

function NHBDashboard() {
  const [todaySurvey, setTodaySurvey] = useState("");
  const [monthSurvey, setMonthSurvey] = useState("");
  const [yearSurvey, setYearSurvey] = useState("");
  const [totalSurvey, setTotalSurvey] = useState("");
  const [schemeObj, setSchemeObj] = useState({})
 
  let countObj = {};


  useEffect(() => {
    const fetchData = async () => {
      let yearInspectionValue = 0;
      let monthInspectionValue = 0;
      let todayInspectionValue = 0;
      let totalInspectionValue = 0;

      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Inspection/inspectionDetails/getInspectionDetailsList`,
        { createdBy: sessionStorage.getItem("userCode") }
      );

      let formsData = result.data.dataContent;
      console.log("formsData", formsData);
      totalInspectionValue = formsData.length;

      var todayDate = new Date();
      var previousDate = new Date(todayDate);

      previousDate.setMonth(previousDate.getMonth() - 1);

      let filterData = [];
     
      let schemeCount = [];
      let inspectionCount = [];
      // This logic is for last 1 month survey
      filterData = formsData.filter((x) => {
        let date = new Date(x.createdOn.split("T")[0].replaceAll("-", ","));
       
        schemeCount.push(x.schemeName.split("-")[0]);
        inspectionCount.push(x.cropCode);

        if (date.getFullYear() === todayDate.getFullYear()) {
          yearInspectionValue++;
          if (date.getMonth() === todayDate.getMonth()) {
            monthInspectionValue++;
            if (date.getDate() === todayDate.getDate()) {
              todayInspectionValue++;
            }
          }
        }

        return previousDate <= date && date <= todayDate;
      });

      // this logic is count number of time element is present in array 
     
     


let countFuncscheme = keys => {
  schemeObj[keys] = ++schemeObj[keys] || 1;
}

console.log("schemeCount" ,schemeCount)


schemeCount.forEach(countFuncscheme);

console.log("schemeObj", schemeObj)
setSchemeObj(schemeObj)

      // This logic is for last 10 survey

      filterData = formsData.slice(0, 10);

      // setFilterArray(filterData)
      setMonthSurvey(monthInspectionValue);
      setYearSurvey(yearInspectionValue);
      setTotalSurvey(totalInspectionValue);
      setTodaySurvey(todayInspectionValue);
    };
    fetchData();
  }, []);
  return (
    <>
      <SideBar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Dashboard</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>
        </div>
        <section className="section dashboard">
          <div className="row">
            <div className="col-xxl-3 col-md-6">
              <div className="card info-card  sales-card bg-gradient-danger card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title">
                    Active Inspection <span>| Today</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{todaySurvey}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">5%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-6">
              <div className="card info-card  sales-card bg-gradient-primary card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title">
                    Active Inspection <span>| Month</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{monthSurvey}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-md-6">
              <div className="card info-card  sales-card bg-gradient-success card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title">
                    Active Inspection <span>| Year</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{yearSurvey}</h6>
                      {/* <span className="text-success small pt-1 fw-bold">8%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-12">
              <div className="card info-card  sales-card bg-gradient-info card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  <h5 className="card-title">
                    Active Inspection <span>| Overall</span>
                  </h5>

                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faUsers} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      <h6>{totalSurvey}</h6>
                      {/* <span className="text-danger small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">decrease</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title">
            Scheme Wise Inspection Count
            </h5>

            <div id="reportsChart"></div>
            {console.log("countObj###", countObj)}
            <Chart
              type="bar"
              series={[
                {
                  name: "Total Inspection",
                  data: Object.values(schemeObj)
                },
              ]}
              options={{
                Chart: {
                  id: "apexchart-example",
                },
                xaxis: {
                  categories: Object.keys(schemeObj)
                },
                colors : ["#95078F"],
                plotOptions: { bar: { horizontal: false, columnWidth: Object.keys(schemeObj).length * 4 + "%", }, },
              }}
              height={450}
            />
          </div>
        </section>
      </main>
    </>
  );
}

export default NHBDashboard;
